import * as R from 'ramda'
import moment from 'moment'

export const FIELD_TYPE_PARSER = {
  date: {
    parse: val => {
      if (R.is(Number, val)) {
        val = val + ''
      }
      let time
      if (val.length === 13 && /^[1-9]\d*$/.test(val)) { // 13位时间戳
        time = moment(parseInt(val)).format('YYYY-MM-DD')
      } else if (val.includes(' UTC')) { // 2023-05-18 18:11:57 UTC+8
        time = moment(new Date(val)).format('YYYY-MM-DD')
      } else if (val.includes('-') || val.includes('/')) { // 2023-11-20 12:00:00 2023/11/1 12:00:00
        time = moment(parseInt(val)).format('YYYY-MM-DD')
      } else if (val.length === 13 && /^[1-9]\d*$/.test(val)) { // 20231220120000
        const str = val.slice(0, 4) + '-' + val.slice(4, 6) + '-' + val.slice(6, 8) + ' ' + val.slice(8, 10) + ':' + val.slice(10, 12) + ':' + val.slice(12, 14)
        time = moment(str).format('YYYY-MM-DD')
      } else if (/^[1-9]\d*\.\d*|0\.\d*[1-9]\d*|^[1-9]\d*$/.test(val)) { // 45250.5
        time = new Date(moment((Number(val) - 25569 + new Date().getTimezoneOffset() / (60 * 24)) * 86400000))
        return moment(time).format('YYYY-MM-DD')
      }
      return time
    },
  },
  time: {
    parse: val => {
      if (R.is(Number, val)) {
        val = val + ''
      }
      let time
      if (val.length === 13 && /^[1-9]\d*$/.test(val)) { // 13位时间戳
        time = moment(parseInt(val)).utc().format('YYYY-MM-DD HH:mm:ss')
      } else if (val.includes(' UTC')) { // 2023-05-18 18:11:57 UTC+8
        time = moment(new Date(val)).utc().format('YYYY-MM-DD HH:mm:ss')
      } else if (val.includes('-') || val.includes('/')) { // 2023-11-20 12:00:00 2023/11/1 12:00:00
        time = moment(parseInt(val)).utc().format('YYYY-MM-DD HH:mm:ss')
      } else if (val.length === 13 && /^[1-9]\d*$/.test(val)) { // 20231220120000
        const str = val.slice(0, 4) + '-' + val.slice(4, 6) + '-' + val.slice(6, 8) + ' ' + val.slice(8, 10) + ':' + val.slice(10, 12) + ':' + val.slice(12, 14)
        time = moment(str).utc().format('YYYY-MM-DD HH:mm:ss')
      } else if (/^[1-9]\d*\.\d*|0\.\d*[1-9]\d*|^[1-9]\d*$/.test(val)) { // 45250.5
        time = new Date((Number(val) - 1) * 24 * 3600000 + 1)
        time.setYear(time.getFullYear() - 70)
        return moment(time).utc().subtract(moment().utcOffset(), 'minutes').format('YYYY-MM-DD HH:mm:ss')
      }
      return time
    },
    formatter: val => {
      if (val) {
        return moment(val).format('YYYY-MM-DD HH:mm:ss')
      }
      return '-'
    },
  },
}
